import classNames from 'classnames';
import { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router';

import Overlay from '@components/Overlay';
import { IntlContext } from '@utils/useIntl';
import NavLinks from './NavLinks';
import { getNavIndex, MOBILE_NAV_LINKS } from './utils';

const lineClassNames =
  'w-full h-px bg-light group-hover:bg-accent transition-colors';

const NavMobile = () => {
  const { pathname } = useLocation();
  const { translate } = useContext(IntlContext);
  const navIndex = getNavIndex(MOBILE_NAV_LINKS, pathname);

  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <div className="desktop:hidden shrink-0 w-header-mobile h-header-mobile p-4">
        <button
          aria-label={translate('nav.button')}
          className="group flex flex-col items-center justify-center gap-2 w-full p-2 h-full cursor-pointer"
          onClick={() => setOpen(true)}
        >
          <span className={lineClassNames} />
          <span className={lineClassNames} />
          <span className={lineClassNames} />
        </button>
      </div>

      {open && (
        <Overlay onClose={close}>
          <div className="flex flex-col items-center justify-around h-full">
            <div></div>
            <ul className="flex flex-col text-4xl lowercase">
              {MOBILE_NAV_LINKS.map(({ label, link }, index) => (
                <Link
                  className={classNames(
                    'w-full p-4 font-title text-center',
                    index === navIndex
                      ? 'text-accent'
                      : 'text-light hover:text-accent transition-colors',
                  )}
                  to={link}
                  onClick={close}
                >
                  {typeof label === 'string' ? translate(label) : label}
                </Link>
              ))}
            </ul>
            <NavLinks className="mt-10 gap-8" size="lg" />
          </div>
        </Overlay>
      )}
    </>
  );
};

export default NavMobile;
